module.exports = __webpack_public_path__ + "media/ambulance.19ed2399.mp3";